import { AuthenticationService } from "../authenticationService";
import { APIService } from "../apiService";
import { ISOString, WarehouseCheckIn, PaginatedWarehouseCheckIns, S3SignedUrl } from "src/types";
import {
  GetWarehouseCheckInsQueryParams,
  PatchWarehouseCheckInOpsNoteRequestBody,
  PostWarehouseCheckInImagesUrlRequestBody,
  PostWarehouseCheckInPurchaseOrderRequestBody,
  PostWarehouseCheckInUnknownArrivalRequestBody
} from "src/types/api";

class WarehouseCheckInAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/warehouse-check-ins");
  }

  async getWarehouseCheckInById(warehouseCheckInId: string, timestamp: ISOString): Promise<WarehouseCheckIn> {
    const idPathParam = encodeURIComponent(warehouseCheckInId);
    const timestampPathParam = encodeURIComponent(timestamp);
    const path = `/${idPathParam}/${timestampPathParam}`;

    return await this.jwtRequest("GET", path);
  }

  async getWarehouseCheckIns(queryParams: GetWarehouseCheckInsQueryParams): Promise<PaginatedWarehouseCheckIns> {
    return await this.jwtRequest("GET", undefined, undefined, queryParams);
  }

  async patchWarehouseCheckInOpsNote(
    warehouseCheckInId: string,
    timestamp: ISOString,
    requestBody: PatchWarehouseCheckInOpsNoteRequestBody
  ): Promise<WarehouseCheckIn> {
    const idPathParam = encodeURIComponent(warehouseCheckInId);
    const timestampPathParam = encodeURIComponent(timestamp);
    const path = `/${idPathParam}/${timestampPathParam}/ops-note`;

    return await this.jwtRequest("PATCH", path, requestBody);
  }

  async postWarehouseCheckInImagesUrls(
    warehouseCheckInId: string,
    requestBody: PostWarehouseCheckInImagesUrlRequestBody
  ): Promise<S3SignedUrl[]> {
    const pathParam = encodeURIComponent(warehouseCheckInId);
    const path = `/${pathParam}/image-urls`;

    return await this.jwtRequest("POST", path, requestBody);
  }

  async postWarehouseCheckInPurchaseOrder(
    purchaseOrderId: string,
    requestBody: PostWarehouseCheckInPurchaseOrderRequestBody
  ): Promise<WarehouseCheckIn> {
    const pathParam = encodeURIComponent(purchaseOrderId);
    const path = `/${pathParam}/purchase-order`;

    return await this.jwtRequest("POST", path, requestBody);
  }

  async postWarehouseCheckInUnknownArrival(
    warehouseCheckInId: string,
    requestBody: PostWarehouseCheckInUnknownArrivalRequestBody
  ): Promise<WarehouseCheckIn> {
    const pathParam = encodeURIComponent(warehouseCheckInId);
    const path = `/${pathParam}/unknown-arrival`;

    return await this.jwtRequest("POST", path, requestBody);
  }

  async postWarehouseCheckInsGoodsInExportUrl(exportFileId: string): Promise<S3SignedUrl> {
    const pathParam = encodeURIComponent(exportFileId);
    const path = `/${pathParam}/goods-in-export-url`;

    return await this.jwtRequest("POST", path);
  }
}

export { WarehouseCheckInAPIService };
